import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import {StyleRoot} from 'radium'

import './normalize.css'
import './main.css'
import 'prismjs/themes/prism-okaidia.css'


//check bottom comment in https://github.com/gatsbyjs/gatsby/issues/1494 for a hack to support multiple layouts

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet>
      <title>Haiku | Create interfaces using design tools, code or both.</title>
      <meta name="description" content="Where designing is building. Create dynamic, cross-platform UIs using design tools, code, or both. Works with any iOS, Android, or Web codebase." />
      <meta property="og:title" content="Haiku" />
      <meta property="og:description" content="Where designing is building. Create dynamic, cross-platform UIs using design tools, code, or both. Works with any iOS, Android, or Web codebase." />
      <meta property="og:image" content={`${process.env.SITE_URL}/img/sum.jpg`} />
      <meta property="og:url" content="https://www.haiku.ai" />
      <meta property="og:site_name" content="Haiku" />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@HaikuForTeams" />
      <meta name="twitter:image:alt" content="Haiku Logo" />
    </Helmet>
    <StyleRoot>
    {children()}
    </StyleRoot>
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.any,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js